<template>
  <v-expansion-panel @click="handleExpansionPanelChange">
    <v-expansion-panel-header
      class="font-weight-medium text-h6"
    >
      {{ titulo }}
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-progress-linear
        v-if="isGetItemsLoading"
        indeterminate
        color="primary"
      />

      <slot v-else>
        <v-expand-transition v-if="items.length">
          <timeline-base
            v-show="expand"
            :items="items"
          />
        </v-expand-transition>

        <v-expand-transition v-else>
          <h4 v-show="expand">
            Nenhum item disponível
          </h4>
        </v-expand-transition>
      </slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { ref } from '@vue/composition-api'
import Vue from 'vue'
import TimelineBase from './timeline/TimelineBase.vue'

export default {
  components: {
    TimelineBase,
  },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    getItems: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const expand = ref(false)

    const isGetItemsLoading = ref(false)
    async function handleExpansionPanelChange(event) {
      if (props.items.length > 0) return
      if (event.currentTarget.classList.contains('v-expansion-panel-header--active')) {
        expand.value = false
      } else {
        expand.value = true
        isGetItemsLoading.value = true

        try {
          await props.getItems()
        } catch {
          Vue.$toast.error('Não foi possível carregar o histórico. Tente novamente.')
        } finally {
          isGetItemsLoading.value = false
        }
      }
    }

    return {
      expand,
      isGetItemsLoading,
      handleExpansionPanelChange,
    }
  },
}
</script>
